export const ACTIVITY_CATEGORY_NEW_DEAL: string = 'new-deal';
export const ACTIVITY_CATEGORY_CAPITAL_RAISE: string = 'capital-raise';
